function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.465 283.465"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.174 42.52h148.819v28.346H14.174zM14.174 127.559h148.819v28.346H14.174zM14.174 212.598h148.819v28.346H14.174zM217.962 92.27l-33.436-33.365 20.13-20.174 13.263 13.235 37.935-38.014 20.174 20.132zM217.962 177.18l-33.436-33.366 20.13-20.174 13.263 13.235 37.935-38.014 20.174 20.132z"
})));